import React, { useEffect, useState } from "react";
import {
  Slider,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  AddPriceDiscountRange,
  EditPriceDiscountRange,
  GetPriceGrouprange,
} from "../../../../Redux/Slices/Sessions/Session.action";
import { useDispatch, useSelector } from "react-redux";
import ActionButton from "../../../../Components/Popups/PopupComponent/ActionButton";
import { toast } from "react-toastify";

const ManagePriceRange = ({ modalcontrols, data }) => {
  const [minPrice, setMinPrice] = useState(data?.min_amount || 0);
  const [maxPrice, setMaxPrice] = useState(data?.max_amount || "");
  const [discount, setDiscount] = useState(data?.discount || "");
  const [rangeError, setRangeError] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const dispatch = useDispatch();
  const Rangedata = useSelector((store) => store?.Sessions);

  const priceGap = 1;

  const doesRangeOverlapBlocked = (min, max) => {
    let filteredRanges = Rangedata?.PriceRange || [];

    if (data) {
      filteredRanges = filteredRanges?.filter((range) => range.id !== data.id);
    }
 
    return filteredRanges?.some((range) => {
      return (
        (min >= range.min_amount && min <= range.max_amount) ||
        (max >= range.min_amount && max <= range.max_amount) ||
        (min <= range.min_amount && max >= range.max_amount) // Range completely covers a blocked range
      );
    });
  };

  // Validate the entire range
  const validateRange = (min, max) => {
    if (min >= max) {
      setRangeError("Min price must be less than Max price.");
    } else if (doesRangeOverlapBlocked(min, max)) {
      setRangeError(
        "Selected discount range overlaps with an existing discount."
      );
    } else {
      setRangeError(""); // No errors
    }
  };

  // Handle input change for min and max price inputs
  const handlePriceInput = (e) => {
    const { value, name } = e.target;
    const valueInt = parseInt(value);

    if (name === "min") {
      setMinPrice(valueInt);
      validateRange(valueInt, maxPrice);
    } else if (name === "max") {
      setMaxPrice(valueInt);
      validateRange(minPrice, valueInt);
    }
  };

  // Handle input change for discount percentage
  const handleDiscountInput = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 0 && value <= 100) {
      setDiscount(value); // Set discount percentage
    } else {
      setDiscount(""); // Clear invalid input
    }
  };

  // Handle slider change
  const handleSliderChange = (event, newValue) => {
    const [newMin, newMax] = newValue;
    setMinPrice(newMin);
    setMaxPrice(newMax);

    // Validate range after slider change
    validateRange(newMin, newMax);
  };

  // Update button state based on validation
  useEffect(() => {
    const isFormValid =
      minPrice !== "" &&
      maxPrice !== "" &&
      discount !== "" &&
      rangeError === "" &&
      parseInt(minPrice) < parseInt(maxPrice) &&
      parseInt(discount) >= 0 &&
      parseInt(discount) <= 100;

    setIsButtonDisabled(!isFormValid);
  }, [minPrice, maxPrice, discount, rangeError]);

  // Fetch price range data
  useEffect(() => {
    dispatch(GetPriceGrouprange());
  }, [dispatch]);

  // Handle Add Price button click
  const handleAddPrice = () => {
    const discountData = new FormData();
    discountData.append("min_amount", minPrice);
    discountData.append("max_amount", maxPrice);
    discountData.append("discount", discount);
    if (data) {
      discountData.append("discount_id", data?.id);
    }
    dispatch(
      data
        ? EditPriceDiscountRange(discountData)
        : AddPriceDiscountRange(discountData)
    )
      .unwrap()
      .then((result) => {
        if (result?.s == 1) {
          toast.success(
            data ? "Discount range updated " : "Discount range added"
          );
          modalcontrols?.closeeditpopup();
        } else {
          toast.error(result?.m);
        }
      });
  };

  return (
    <Box
      className="wrapper"
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: 2,
        p: 3,
        boxShadow: 2,
      }}
    >
      {/* Min-Max Price Inputs */}
      <Box className="price-input" sx={{ display: "flex", my: 2 }}>
        <TextField
          label="Min"
          name="min"
          type="number"
          value={minPrice}
          onChange={handlePriceInput}
          variant="outlined"
          sx={{
            width: "100%",
            borderRadius: "10px",
            outline: "none",
            mr: 1,
          }}
          error={!!rangeError} // Highlight input if error exists
        />
        <Typography variant="h6" sx={{ alignSelf: "center" }}>
          -
        </Typography>
        <TextField
          sx={{
            width: "100%",
            borderRadius: "10px",
            ml: 1,
          }}
          label="Max"
          name="max"
          type="number"
          value={maxPrice}
          onChange={handlePriceInput}
          variant="outlined"
          error={!!rangeError} // Highlight input if error exists
        />
      </Box>

      {/* Error Message */}
      {rangeError && (
        <Typography color="error" sx={{ mb: 2 }}>
          {rangeError}
        </Typography>
      )}

      <Box
        sx={{
          color: "black",
          display: "flex",
          alignItems: "center",
          width: "100%",
          m: "auto",
        }}
      >
        Existing Discount Range
        <Box
          sx={{
            color: "black",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "50%",
            m: "auto",
            maxHeight: "200px",
            overflow: "auto",
            my: "20px",
            pr: "10px",
          }}
        >
          <Box
            sx={{
              border: "1px solid #F68582 ",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              paddingX: "20px",
              paddingY: "5px",
              borderRadius: "10px",
              bgcolor: "#F68582",
              color: "white",
            }}
          >
            <Typography sx={{ fontFamily: "sans-serif" }}>Min </Typography>
            <Typography> Max </Typography>
          </Box>
          {(data
            ? Rangedata?.PriceRange?.filter((range) => range.id !== data.id)
            : Rangedata?.PriceRange
          )?.length == 0 ? (
            <Typography>No Data </Typography>
          ) : (
            (data
              ? Rangedata?.PriceRange?.filter((range) => range.id !== data.id)
              : Rangedata?.PriceRange
            )?.map((el) => (
              <Box
                sx={{
                  border: "1px solid #F68582 ",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  paddingX: "20px",
                  paddingY: "2px",
                  borderRadius: "10px",
                }}
              >
                {" "}
                <Typography sx={{ fontFamily: "sans-serif" }}>
                  {" "}
                  {el?.min_amount}
                </Typography>{" "}
                -{" "}
                <Typography sx={{ fontFamily: "sans-serif" }}>
                  {" "}
                  {el?.max_amount}
                </Typography>
              </Box>
            ))
          )}
        </Box>
      </Box>

      {/* Range Slider */}
      <Slider
        value={[minPrice || 0, maxPrice || 0]}
        onChange={handleSliderChange}
        valueLabelDisplay="auto"
        min={0}
        max={1000}
        step={priceGap}
        sx={{
          mt: 1,
          color: "#F68582",
        }}
      />

      {/* Discount Input */}
      <Box sx={{ my: 2 }}>
        <TextField
          label="Discount (%)"
          type="number"
          value={discount}
          onChange={handleDiscountInput}
          variant="outlined"
          sx={{ width: "100%" }}
          inputProps={{ min: 0, max: 100 }}
        />
      </Box>

      {/* Add Price Button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "40%",
          m: "auto",
          mt: "20px",
          gap: "10px",
        }}
      >
        <ActionButton
          title={
            Rangedata?.loading ? (
              <CircularProgress sx={{ color: "#fff" }} />
            ) : data ? (
              "Edit "
            ) : (
              "Add"
            )
          }
          onclick={handleAddPrice}
          disabled={isButtonDisabled || Rangedata?.loading} // Disable button based on validation
        />
      </Box>
    </Box>
  );
};

export default ManagePriceRange;
